import React from "react";
import "../styles/MatrimonialRegistrationPage.css";
import bhriguLogo from "../assets/images/bhrigu-logo.gif";
import pic1 from "../assets/images/matrimonial-pic1.png";
import pic2 from "../assets/images/matrimonial-pic2.png";
import pic3 from "../assets/images/matrimonial-pic3.png";

const MatrimonialRegistrationPage = () => {
  return (
    <div className="matrimonial-page">
    <div className="container-matrimonial">
      {/* LEFT PANEL */}
      <div className="col-70 profileleftpanel">
        <div className="row">
          <div className="col-15">
            <button>Self</button>
            <br />
            <button>Other</button>
          </div>
          <div className="col-75 animated-title">
            <h2>Registration for Bandhan Sutra</h2>
          </div>
        </div>

        <div className="row">
          {/* LEFT FORM COLUMN */}
          <div className="col-50">
            <div className="form-row"><input type="text" placeholder="Name" /></div>

            <div className="form-row">
              <div className="row">
                <div className="col-60"><input type="text" placeholder="Date of Birth" /></div>
                <div className="col-40"><input type="text" placeholder="Time" /></div>
              </div>
            </div>

            <div className="form-row">
              <div className="row">
                <div className="col-60"><input type="text" placeholder="Place of Birth" /></div>
                <div className="col-40"><input type="text" placeholder="Male / Female" /></div>
              </div>
            </div>

            <div className="form-row"><input type="text" placeholder="Highest Education 1" /></div>
            <div className="form-row"><input type="text" placeholder="Highest Education 2" /></div>
            <div className="form-row"><input type="text" placeholder="Profession" /></div>
            <div className="form-row"><input type="text" placeholder="Monthly Income in Rs." /></div>

            <div className="form-row">
              <div className="row">
                <div className="col-48"><input type="text" placeholder="Height in Feet" /></div>
                <div className="col-48"><input type="text" placeholder="Weight in Kg" /></div>
              </div>
            </div>

            <div className="form-row">
              <div className="row">
                <div className="col-48"><input type="text" placeholder="Complexion" /></div>
                <div className="col-48"><input type="text" placeholder="Blood Group" /></div>
              </div>
            </div>

            <div className="form-row">
              <div className="row">
                <div className="col-48"><input type="text" placeholder="Gotra" /></div>
                <div className="col-48"><input type="text" placeholder="Kuldevi" /></div>
              </div>
            </div>

            <div className="form-row"><input type="text" placeholder="Father’s Name" /></div>
            <div className="form-row"><input type="text" placeholder="Occupation" /></div>
            <div className="form-row"><input type="text" placeholder="Mother’s Name" /></div>
            <div className="form-row"><input type="text" placeholder="Occupation" /></div>
          </div>

          {/* RIGHT FORM COLUMN */}
          <div className="col-50">
            <div className="form-row"><input type="text" placeholder="Sibling 1" /></div>
            <div className="form-row"><input type="text" placeholder="Sibling 2" /></div>
            <div className="form-row"><input type="text" placeholder="Sibling 3" /></div>
            <div className="form-row"><input type="text" placeholder="Dadaji" /></div>
            <div className="form-row"><input type="text" placeholder="Dadiji" /></div>
            <div className="form-row"><input type="text" placeholder="Nanaji" /></div>
            <div className="form-row"><input type="text" placeholder="Naniji" /></div>

            <div className="form-row"><input type="text" placeholder="References" /></div>
            <div className="form-row"><input type="text" placeholder="References" /></div>
            <div className="form-row"><input type="text" placeholder="References" /></div>
            <div className="form-row"><input type="text" placeholder="References" /></div>

            <div className="form-row"><input type="text" placeholder="Correspondence Address" /></div>
            <div className="form-row"><input type="text" placeholder="Correspondence Address" /></div>

            <div className="form-row">
              <div className="row">
                <div className="col-48"><input type="email" placeholder="Email" /></div>
                <div className="col-48"><input type="tel" placeholder="Phone" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT PANEL */}
      <div className="col-30">
        <div className="col-100 logo-div text-center">
          <img src={bhriguLogo} alt="Bhrigu" />
        </div>

        <div className="row matrimonial-img-div">
          <div className="martinomial-img">
            <div className="row">
              <div className="leftpanelimgcontainer">
                <div className="martfigure"><img src={pic1} alt="Matrimonial 1" /></div>
                <div className="martfigure"><img src={pic2} alt="Matrimonial 2" /></div>
              </div>
              <div className="rightpanelimgcontainer">
                <div className="martfigure"><img src={pic3} alt="Matrimonial 3" /></div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-100 profile-pic">
          <caption>Please attach 3 pictures as shown in the boxes.</caption>
        </div>

        <div className="col-100 text-center submission-div">
          <button>Submit</button>
          <p>
            Please check your mail after
            <br />
            successful submission
          </p>
        </div>
      </div>
    </div>
    </div>
  );
};

export default MatrimonialRegistrationPage;
